import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAiToolPricing } from '../../hooks/useAiToolPricing'

const VARIANTS = {
  card: {
    fontSize: 13,
    fontWeight: 700,
    px: 1.25,
    py: 0.375,
    borderRadius: '999px',
    border: '1px solid rgba(221, 171, 46, 0.45)',
    bgcolor: 'rgba(221, 171, 46, 0.12)',
    color: '#DDAB2E',
    letterSpacing: '0.02em',
  },
  hero: {
    fontSize: 12,
    fontWeight: 600,
    px: 2.25,
    py: 1.25,
    borderRadius: '12px',
    border: '1px solid var(--gold-border)',
    bgcolor: 'transparent',
    color: 'var(--gold)',
    letterSpacing: '0.3px',
    lineHeight: 1.2,
    minHeight: 'auto',
    boxSizing: 'border-box',
  },
  sidebar: {
    fontSize: 9,
    fontWeight: 600,
    px: 0.75,
    py: 0.25,
    borderRadius: '6px',
    border: '1px solid rgba(221, 171, 46, 0.35)',
    bgcolor: 'rgba(221, 171, 46, 0.14)',
    color: '#DDAB2E',
    letterSpacing: '0.04em',
    lineHeight: 1.2,
  },
  inline: {
    fontSize: 11,
    fontWeight: 500,
    px: 0,
    py: 0,
    borderRadius: 0,
    border: 'none',
    bgcolor: 'transparent',
    color: 'rgba(221, 171, 46, 0.85)',
    letterSpacing: '0.04em',
  },
}

function AiToolPriceBadge({
  pricingType,
  toolType,
  mode,
  variant = 'hero',
  suffix = 'per report',
  showSuffix = true,
  className,
}) {
  const { getPricingLabel, getPricingAmount, loaded } = useAiToolPricing()
  const styles = VARIANTS[variant] || VARIANTS.hero

  if (!loaded) {
    return null
  }

  const label = showSuffix
    ? getPricingLabel({ pricingType, toolType, mode, suffix, showSuffix })
    : getPricingAmount({ pricingType, toolType, mode })

  if (!label) {
    return null
  }

  return (
    <Box
      className={
        className ||
        (variant === 'hero' ? 'ai-tool-price-badge' : undefined)
      }
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
        ...styles,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
          letterSpacing: 'inherit',
          lineHeight: 'inherit',
          textTransform: styles.textTransform || 'none',
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default AiToolPriceBadge
